/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import './VisaPage.scss';
import { useIntl } from 'react-intl';
import { subDays } from 'date-fns';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import AppSelect from '../../shared/components/app-select/AppSelect';
import { countryOptionsForHotelPax } from '../../shared/constants/CountryOptions';
import AppNumberInput from '../../shared/components/app-number-input/AppNumberInput';
import AppButton from '../../shared/components/app-button/AppButton';
import {
  sendVisaRequest,
  getUserDetails,
  sendVisaRequestApi,
} from '../../api/profileApi';
import {
  getUserAgentId,
  getValueFromAppConfig,
} from '../../shared/helper-utils/localStorage';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import {
  formatDate,
  getAPIFormattedDate,
  getNewDate,
} from '../../shared/helper-utils/appUtils';
import {
  API_DATE_FORMAT,
  checkValidName,
  TODAY_DATE,
} from '../../shared/constants/Constants';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import { useAppContext } from '../../saas/AppConfigWrapper';
import AppDatePicker from '../../shared/components/app-date-picker/AppDatePicker';

const VISA_TYPE_OPTIONS = [
  { label: 'Tourist', value: 'Tourist' },
  { label: 'Business', value: 'Business' },
  { label: 'Transit', value: 'Transit' },
];
const NO_OF_ENTRIES = [
  { label: 'Single', value: 'Single' },
  { label: 'Double', value: 'Double' },
  { label: 'Multiple', value: 'Multiple' },
];
const GENDER_OPTIONS = [
  { label: 'Male', value: 'male' },
  { label: 'Female', value: 'female' },
];
const TITLE_OPTIONS = [
  { label: 'Mr', value: 'Mr' },
  { label: 'Mrs', value: 'Mrs' },
  { label: 'Miss', value: 'Miss' },
  { label: 'Dr', value: 'Dr' },
  { label: 'ER', value: 'ER' },
  { label: 'FR', value: 'FR' },
  { label: 'Capt', value: 'Capt' },
  { label: 'Mstr', value: 'Mstr' },
  { label: 'Others', value: 'Others' },
];

const REQUIRE_TRANSIT_TYPE = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' },
];

const isEmpty = (value) => {
  if (value === '' || value === null || value === undefined) {
    return true;
  }
  return false;
};

function VisaPage() {
  const { appConfig } = useAppContext();
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const [validationError, setValidationError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState(undefined);
  const [visaRequest, setVisaRequest] = useState({
    visiting_country: '',
    travel_from_date: '',
    travel_to_date: '',
    visa_type: 'Tourist',
    no_of_entry: 'Single',
    visiting_purpose: '',
    require_transit_visa: '',
    title: 'Mr',
    invitee_email: '',
    invitee_mobile: '',
    invitee_address: '',
    invitee_name: '',
    contact_name: '',
    invitee_company_mail: '',
    invitee_company_number: '',
    invitee_company_address: '',
    invitee_company_name: '',
    company_email_id: '',
    company_number: '',
    designation: '',
    company_address: '',
    company_name: '',
    company_profile: '',
    hotel_email: '',
    hotel_number: '',
    hotel_address: '',
    hotel_name: '',
    travel_date: '',
    arrival_airport: '',
    departure_airport: '',
    booking_confirmation: '',
    flight_no: '',
    passport_address: '',
    dob_place: '',
    passport_expiry: '',
    passport_issue: '',
    passport_issue_place: appConfig?.hotelPaxCountry,
    passport_number: '',
    gender: '',
    dob: '',
    nationality: appConfig?.hotelPaxCountry,
    last_name: '',
    first_name: '',
  });

  const handleUpdateState = (name, value) => {
    setVisaRequest((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const countryOptions = countryOptionsForHotelPax.map((country) => ({
    label: country,
    value: country,
  }));

  const handleSubmit = async () => {
    if (
      isEmpty(visaRequest.visiting_country) ||
      isEmpty(visaRequest.travel_from_date) ||
      isEmpty(visaRequest.travel_to_date) ||
      isEmpty(visaRequest.visa_type) ||
      isEmpty(visaRequest.visiting_purpose) ||
      isEmpty(visaRequest.title) ||
      isEmpty(visaRequest.first_name) ||
      isEmpty(visaRequest.last_name) ||
      isEmpty(visaRequest.nationality) ||
      isEmpty(visaRequest.dob) ||
      isEmpty(visaRequest.gender) ||
      isEmpty(visaRequest.passport_issue) ||
      isEmpty(visaRequest.passport_expiry) ||
      isEmpty(visaRequest.travel_date)
    ) {
      setValidationError(true);
      return false;
    }
    if (visaRequest.require_transit_visa === '') {
      visaRequest.require_transit_visa = 'No';
    }
    if (
      getNewDate(visaRequest.travel_from_date) >
      getNewDate(visaRequest.travel_to_date)
    ) {
      setAlert({
        title: 'Visa Request',
        description: 'Travel Date From cannot be greater than Travel Date To',
        variant: 'error',
      });
      setIsLoading(false);
      return false;
    }
    setIsLoading(true);
    const req = {
      ...visaRequest,
    };
    req.travel_from_date = formatDate(
      getNewDate(visaRequest.travel_from_date),
      API_DATE_FORMAT,
    );
    req.travel_to_date = formatDate(
      getNewDate(visaRequest.travel_to_date),
      API_DATE_FORMAT,
    );
    req.dob = formatDate(getNewDate(visaRequest.dob), API_DATE_FORMAT);
    if (!isEmpty(req.travel_date)) {
      req.travel_date = formatDate(
        getNewDate(visaRequest.travel_date),
        API_DATE_FORMAT,
      );
    }
    if (!isEmpty(req.passport_issue)) {
      req.passport_issue = formatDate(
        getNewDate(visaRequest.passport_issue),
        API_DATE_FORMAT,
      );
    }
    if (!isEmpty(req.passport_expiry)) {
      req.passport_expiry = formatDate(
        getNewDate(visaRequest.passport_expiry),
        API_DATE_FORMAT,
      );
    }

    const res = await getUserDetails(getUserAgentId());
    if (res.ApiStatus?.Status === 'OK') {
      const { User } = res.ApiStatus.Result;
      const fromEmail = User.ContactEmail;
      const fromName = getValueFromAppConfig('SAAS_PROJECT_NAME');
      const toEmail = getValueFromAppConfig('SUPPORTEMAILID');
      const emailSubject = `Visa Form Request - RE${Math.random() * 10000}`;
      const reqResponse = await sendVisaRequestApi(
        req,
        fromEmail,
        fromName,
        toEmail,
        emailSubject,
      );
      // const emailContent = `<div style='width:700px;margin:auto;font-size:12px;line-height: 23px;border: 1px solid #000;padding: 15px;'><p style='font-weight:bold'>Dear Admin , <br><br> The following Visa request has been raised.<br></p></hr><hr><h3>Visa Query :</h3><table border='1' cellpadding='5' cellspacing='0' style='width:100%;font-size:12px;line-height: 23px;border:1px solid #000'><tr><td style='width:30%'><b>Visiting To :</b> <span>${
      //   visaRequest.visiting_country
      // }</span></td><td style='width:30%'><b>Travel Date from :</b> ${formatDate(
      //   getNewDate(visaRequest.travel_from_date),
      //   API_DATE_FORMAT,
      // )}</td><td  style='width:30%'><b>Travel Date To : </b> ${formatDate(
      //   getNewDate(visaRequest.travel_to_date),
      //   API_DATE_FORMAT,
      // )}</td></tr><tr><td  style='width:30%'><b>Visa Type :</b> ${
      //   visaRequest.visa_type
      // }</td><td><b>Number of Entry : </b> ${
      //   visaRequest.no_of_entry
      // }</td><td><b>Visiting Purpose : </b> ${
      //   visaRequest.visiting_purpose
      // }</td></tr><tr><td colspan='3'><b>Do you require Transit Visa? </b>: ${
      //   visaRequest.require_transit_visa
      // } </td></tr></table><h3>Personal Information :</h3><table border='1' cellpadding='5' cellspacing='0' style='width:100%;font-size:12px;line-height: 23px;border:1px solid #000'><tr><td style='width:30%'><b>Title :</b> <span>${
      //   visaRequest.title
      // }</span></td><td style='width:30%'><b>First Name :</b> ${
      //   visaRequest.first_name
      // }</td><td  style='width:30%'><b>Last Name : </b> ${
      //   visaRequest.last_name
      // }</td></tr><tr><td  style='width:30%'><b>Nationality :</b> ${
      //   visaRequest.nationality
      // }</td><td><b>DOB : </b> ${formatDate(
      //   getNewDate(visaRequest.dob),
      //   API_DATE_FORMAT,
      // )}</td><td><b>Sex : </b> ${
      //   visaRequest.gender
      // }</td></tr></table><h3>Flight Details :</h3><table border='1' cellpadding='5' cellspacing='0' style='width:100%;font-size:12px;line-height: 23px;border:1px solid #000'><tr><td style='width:30%'><b>Flight No :</b> <span>${
      //   visaRequest.flight_no
      // }</span></td><td style='width:30%'><b>Booking Confirmation :</b> ${
      //   visaRequest.booking_confirmation
      // }</td><td  style='width:30%'><b>Departure Airport : </b> ${
      //   visaRequest.departure_airport
      // }</td></tr><tr><td  style='width:30%'><b>Arrival Airport :</b> ${
      //   visaRequest.arrival_airport
      // }</td><td colspan='2'><b>Travel Date : </b> ${
      //   visaRequest.travel_date !== ''
      //     ? formatDate(getNewDate(visaRequest.travel_date), API_DATE_FORMAT)
      //     : ''
      // }</td></tr></table><h3>Hotel Details :</h3><table border='1' cellpadding='5' cellspacing='0' style='width:100%;font-size:12px;line-height: 23px;border:1px solid #000'><tr><td colspan='3' style='width:30%'><b>Name :</b> <span>${
      //   visaRequest.hotel_name
      // }</span></td><td style='width:30%'><b>Address :</b> ${
      //   visaRequest.hotel_address
      // }</td><td  style='width:30%'><b>Tel No : </b> ${
      //   visaRequest.hotel_number
      // }</td></tr><tr><td colspan='5'  style='width:30%'><b>Email Id : </b>${
      //   visaRequest.hotel_email
      // }</td></tr></table><h3>Company Profile :</h3><table border='1' cellpadding='5' cellspacing='0' style='width:100%;font-size:12px;line-height: 23px;border:1px solid #000'><tr><td colspan='5' style='width:30%'><b>Company Name :</b> <span>${
      //   visaRequest.company_profile
      // }</span></td></tr><tr><td colspan='5'><b>Company Details : </b></td></tr><tr><td><b>Name : </b><span>${
      //   visaRequest.company_name
      // }</span></td><td><b>Address : </b><span>${
      //   visaRequest.company_address
      // }</span></td><td><b>Destignation : </b><span>${
      //   visaRequest.designation
      // }</span></td></tr><tr><td><b>Tel No : </b><span>${
      //   visaRequest.company_number
      // }</span></td><td colspan='3'><b>Email Id : </b><span>${
      //   visaRequest.company_email_id
      // }</span></td></tr><tr><td colspan='5'><b>Invitee Company : </b></td></tr><tr><td><b>Company Name : </b><span>${
      //   visaRequest.invitee_company_name
      // }</span></td><td><b>Address : </b><span>${
      //   visaRequest.invitee_company_address
      // }</span></td><td><b>Tel No : </b><span>${
      //   visaRequest.invitee_company_number
      // }</span></td></tr><tr><td><b>Email Id : </b><span>${
      //   visaRequest.invitee_company_mail
      // }</span></td><td colspan='3'><b>Contact Person Name : </b><span>${
      //   visaRequest.contact_name
      // }</span></td></tr><tr><td colspan='5'><b>Invitee Person : </b></td></tr><tr><td><b>Name : </b><span>${
      //   visaRequest.invitee_name
      // }</span></td><td><b>Address : </b><span>${
      //   visaRequest.invitee_address
      // }</span></td><td><b>Tel No : </b><span>${
      //   visaRequest.invitee_mobile
      // }</span></td></tr><tr><td colspan='5'><b>Email Id : </b><span>${
      //   visaRequest.invitee_email
      // }</span></td></tr></table></div><div style='width:700px;margin:auto;font-size:12px;line-height: 23px;padding:15px;font-weight:bold'>Visa form Submitted By:  ${getUserAgentId()} ------ ${
      //   User.Company
      // }--------- ${User.City}</div>`;
      // const response = await sendVisaRequest(
      //   emailSubject,
      //   fromName,
      //   fromEmail,
      //   toEmail,
      //   emailContent,
      // );
      if (reqResponse && reqResponse.Root && reqResponse.Root.Status === 'OK') {
        setAlert({
          title: 'Visa Request',
          description: 'Request Submitted Successfully',
          variant: 'success',
        });
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        setAlert({
          title: 'Visa Request',
          description: 'Failed to submit request',
          variant: 'error',
        });
      }
    }
    setIsLoading(false);
  };

  return (
    <div className="visa-page pb-3">
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          description={alert.description}
          onHide={() => {
            setAlert(undefined);
          }}
        />
      )}
      <div className="visa-page_banner" />
      <div className="visa-page_container">
        <div className="visa-page_container_header">Visa Request Form</div>
        <div className="visa-page_container_form my-2">
          <Row className="spacing-16 mt-2">
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppSelect
                name="visiting_country"
                label="Visiting To"
                required
                options={countryOptions}
                placeholder=""
                onSelect={(obj) =>
                  handleUpdateState('visiting_country', obj.value)
                }
                isClearable={false}
                selectedValue={visaRequest.visiting_country}
                errorText={validationError && 'please select visiting country'}
              />
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppSelect
                name="visa_type"
                label="Visa Type"
                required
                placeholder=""
                options={VISA_TYPE_OPTIONS}
                onSelect={(obj) => handleUpdateState('visa_type', obj.value)}
                isClearable={false}
                selectedValue={visaRequest.visa_type}
                errorText={validationError && 'please select Visa Type'}
              />
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppSelect
                name="no_of_entry"
                placeholder=""
                label="Number of Entries"
                options={NO_OF_ENTRIES}
                onSelect={(obj) => handleUpdateState('no_of_entry', obj.value)}
                isClearable={false}
                selectedValue={visaRequest.no_of_entry}
              />
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppTextInput
                label="Visiting Purpose"
                name="visiting_purpose"
                required
                placeholderText=""
                value={visaRequest.visiting_purpose}
                onChange={(e) =>
                  handleUpdateState('visiting_purpose', e.target.value)
                }
                errorText={validationError && 'please select visiting purpose'}
              />
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              {/* <AppTextInput
                label="Do you require transit Visa?"
                name="require_transit_visa"
                placeholderText=""
                value={visaRequest.require_transit_visa}
                onChange={(e) =>
                  handleUpdateState('require_transit_visa', e.target.value)
                }
              /> */}
              <AppSelect
                name="require_transit_visa"
                placeholder=""
                label="Do you require transit Visa?"
                options={REQUIRE_TRANSIT_TYPE}
                onSelect={(obj) =>
                  handleUpdateState('require_transit_visa', obj.value)
                }
                isClearable={false}
                selectedValue={visaRequest.require_transit_visa}
              />
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              {/* <AppTextInput
                label="Travel Date From"
                type="date"
                name="travel_from_date"
                required
                placeholderText=""
                value={visaRequest.travel_from_date}
                onChange={(e) =>
                  handleUpdateState('travel_from_date', e.target.value)
                }
                errorText={validationError && 'please enter from date'}
              /> */}
              <AppDatePicker
                label="Travel Date From"
                className="app-date-picker"
                customClassName="position-relative flight-booking-picker"
                name="travel_from_date"
                isCustomeInput={false}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                required
                minDate={new Date()}
                selectedDate={visaRequest.travel_from_date}
                onChange={(date) => handleUpdateState('travel_from_date', date)}
                labelClassName="booking-date-label"
                errorText={validationError && 'please enter from date'}
              />
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              {/* <AppTextInput
                label="Travel Date To"
                type="date"
                name="travel_to_date"
                required
                placeholderText=""
                value={visaRequest.travel_to_date}
                onChange={(e) =>
                  handleUpdateState('travel_to_date', e.target.value)
                }
                errorText={validationError && 'please enter to date'}
              /> */}
              <AppDatePicker
                label="Travel Date To"
                className="app-date-picker"
                customClassName="position-relative flight-booking-picker"
                isCustomeInput={false}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                name="travel_to_date"
                required
                minDate={
                  !isEmpty(visaRequest.travel_from_date)
                    ? visaRequest.travel_from_date
                    : new Date()
                }
                selectedDate={visaRequest.travel_to_date}
                onChange={(date) => handleUpdateState('travel_to_date', date)}
                labelClassName="booking-date-label"
                errorText={validationError && 'please enter to date'}
              />
            </Col>
          </Row>
        </div>
        <div className="visa-page_container_form my-2">
          <h5>Personal Information</h5>
          <Row className="spacing-16">
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppSelect
                name="title"
                placeholder=""
                label="Title"
                options={TITLE_OPTIONS}
                onSelect={(obj) => handleUpdateState('title', obj.value)}
                isClearable={false}
                selectedValue={visaRequest.title}
                errorText={validationError && 'please select title'}
              />
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppTextInput
                label="First Name"
                name="first_name"
                required
                placeholderText="As per Passport"
                value={visaRequest.first_name}
                onChange={(e) =>
                  handleUpdateState('first_name', e.target.value)
                }
                errorText={validationError && 'please enter first name'}
              />
              {checkValidName(visaRequest.first_name) &&
                !isEmpty(visaRequest.first_name) && (
                  <small className="app-error-text pe-1">
                    Please enter valid first name
                  </small>
                )}
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppTextInput
                label="Last Name"
                name="last_name"
                required
                placeholderText="As per Passport"
                value={visaRequest.last_name}
                onChange={(e) => handleUpdateState('last_name', e.target.value)}
                errorText={validationError && 'please enter last name'}
              />
              {checkValidName(visaRequest.last_name) &&
                !isEmpty(visaRequest.last_name) && (
                  <small className="app-error-text">
                    Please enter valid last name
                  </small>
                )}
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppSelect
                name="nationality"
                label="Nationality"
                required
                placeholder=""
                options={countryOptions}
                onSelect={(obj) => handleUpdateState('nationality', obj.value)}
                isClearable={false}
                selectedValue={visaRequest.nationality}
                errorText={validationError && 'please select nationality'}
              />
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              {/* <AppTextInput
                label="Dob"
                type="date"
                name="dob"
                required
                placeholderText=""
                value={visaRequest.dob}
                onChange={(e) => handleUpdateState('dob', e.target.value)}
                errorText={validationError && 'please enter dob'}
              /> */}
              <AppDatePicker
                label="Dob"
                className="app-date-picker"
                customClassName="position-relative flight-booking-picker"
                isCustomeInput={false}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                name="dob"
                required
                maxDate={new Date()}
                selectedDate={visaRequest.dob}
                onChange={(date) => handleUpdateState('dob', date)}
                labelClassName="booking-date-label"
                errorText={validationError && 'please enter dob'}
              />
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppSelect
                name="gender"
                label="Sex"
                placeholder=""
                options={GENDER_OPTIONS}
                onSelect={(obj) => handleUpdateState('gender', obj.value)}
                isClearable={false}
                selectedValue={visaRequest.gender}
                errorText={validationError && 'please select gender'}
                required
              />
            </Col>
          </Row>
        </div>
        <div className="visa-page_container_form my-2">
          <h5>Passport Details</h5>
          <Row className="spacing-16">
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppTextInput
                label="Passport Number"
                name="passport_number"
                required
                placeholderText=""
                value={visaRequest.passport_number}
                onChange={(e) =>
                  handleUpdateState('passport_number', e.target.value)
                }
                errorText={validationError && 'please enter passport number'}
              />
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppSelect
                name="passport_issue_place"
                label="Place of Issue"
                required
                placeholder=""
                options={countryOptions}
                onSelect={(obj) =>
                  handleUpdateState('passport_issue_place', obj.value)
                }
                errorText={validationError && 'please enter place of issue'}
                isClearable={false}
                selectedValue={visaRequest.passport_issue_place}
              />
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              {/* <AppTextInput
                label="Date of Issue"
                type="date"
                name="passport_issue"
                required
                placeholderText=""
                value={visaRequest.passport_issue}
                onChange={(e) =>
                  handleUpdateState('passport_issue', e.target.value)
                }
                errorText={validationError && 'please enter date of issue'}
              /> */}
              <AppDatePicker
                className="app-date-picker"
                customClassName="position-relative flight-booking-picker"
                isCustomeInput={false}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                label="Date of Issue"
                name="passport_issue"
                required
                maxDate={
                  visaRequest.travel_from_date
                    ? subDays(visaRequest.travel_from_date, 1)
                    : new Date()
                }
                selectedDate={visaRequest.passport_issue}
                onChange={(date) => handleUpdateState('passport_issue', date)}
                labelClassName="booking-date-label"
                errorText={validationError && 'please enter date of issue'}
              />
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              {/* <AppTextInput
                label="Date of Expiry"
                type="date"
                name="passport_expiry"
                required
                placeholderText=""
                value={visaRequest.passport_expiry}
                onChange={(e) =>
                  handleUpdateState('passport_expiry', e.target.value)
                }
                errorText={validationError && 'please enter date of expiry'}
              /> */}
              <AppDatePicker
                label="Date of Expiry"
                className="app-date-picker"
                customClassName="position-relative flight-booking-picker"
                isCustomeInput={false}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                name="passport_expiry"
                required
                minDate={
                  !isEmpty(visaRequest.passport_issue)
                    ? visaRequest.passport_issue
                    : new Date()
                }
                selectedDate={visaRequest.passport_expiry}
                onChange={(date) => handleUpdateState('passport_expiry', date)}
                labelClassName="booking-date-label"
                errorText={validationError && 'please enter date of expiry'}
              />
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppTextInput
                label="Place of Birth"
                name="dob_place"
                required
                placeholderText="As per Passport"
                value={visaRequest.dob_place}
                onChange={(e) => handleUpdateState('dob_place', e.target.value)}
                errorText={validationError && 'please enter birth place'}
              />
              {checkValidName(visaRequest.dob_place) &&
                !isEmpty(visaRequest.dob_place) && (
                  <small className="app-error-text pe-1">
                    Please enter valid input
                  </small>
                )}
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppTextInput
                label="Address"
                name="passport_address"
                required
                placeholderText="As per Passport"
                value={visaRequest.passport_address}
                onChange={(e) =>
                  handleUpdateState('passport_address', e.target.value)
                }
                errorText={validationError && 'please enter address'}
              />
            </Col>
          </Row>
        </div>
        <div className="visa-page_container_form my-2">
          <h5>Flight Details</h5>
          <Row className="spacing-16">
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppTextInput
                label="Flight Number"
                name="flight_no"
                placeholderText=""
                value={visaRequest.flight_no}
                onChange={(e) => handleUpdateState('flight_no', e.target.value)}
              />
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppTextInput
                label="Booking Confirmation"
                name="booking_confirmation"
                placeholderText=""
                value={visaRequest.booking_confirmation}
                onChange={(e) =>
                  handleUpdateState('booking_confirmation', e.target.value)
                }
              />
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppTextInput
                label="Departure Airport"
                name="departure_airport"
                placeholderText=""
                value={visaRequest.departure_airport}
                onChange={(e) =>
                  handleUpdateState('departure_airport', e.target.value)
                }
              />
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppTextInput
                label="Arrival Airport"
                name="arrival_airport"
                placeholderText=""
                value={visaRequest.arrival_airport}
                onChange={(e) =>
                  handleUpdateState('arrival_airport', e.target.value)
                }
              />
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              {/* <AppTextInput
                label="Travel Date"
                type="date"
                name="travel_date"
                placeholderText=""
                value={visaRequest.travel_date}
                onChange={(e) =>
                  handleUpdateState('travel_date', e.target.value)
                }
              /> */}
              <AppDatePicker
                label="Travel Date"
                className="app-date-picker"
                customClassName="position-relative flight-booking-picker"
                isCustomeInput={false}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                name="travel_date"
                required
                minDate={new Date()}
                selectedDate={visaRequest.travel_date}
                onChange={(date) => handleUpdateState('travel_date', date)}
                labelClassName="booking-date-label"
                errorText={validationError && 'please enter travel date'}
              />
            </Col>
          </Row>
        </div>
        <div className="visa-page_container_form my-2">
          <h5>Hotel Details</h5>
          <Row className="spacing-16">
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppTextInput
                label="Name"
                name="hotel_name"
                placeholderText=""
                value={visaRequest.hotel_name}
                onChange={(e) =>
                  handleUpdateState('hotel_name', e.target.value)
                }
              />
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppTextInput
                label="Address"
                name="hotel_address"
                placeholderText=""
                value={visaRequest.hotel_address}
                onChange={(e) =>
                  handleUpdateState('hotel_address', e.target.value)
                }
              />
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppTextInput
                label="Tel No"
                name="hotel_number"
                placeholderText=""
                value={visaRequest.hotel_number}
                onChange={(e) =>
                  handleUpdateState('hotel_number', e.target.value)
                }
              />
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppTextInput
                label="Email Id"
                name="hotel_email"
                placeholderText=""
                value={visaRequest.hotel_email}
                onChange={(e) =>
                  handleUpdateState('hotel_email', e.target.value)
                }
              />
            </Col>
          </Row>
        </div>
        <div className="visa-page_container_form my-2">
          <h5>Company Profile</h5>
          <Row className="spacing-16">
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppTextInput
                label="Company Name"
                name="company_profile"
                placeholderText=""
                value={visaRequest.company_profile}
                onChange={(e) =>
                  handleUpdateState('company_profile', e.target.value)
                }
              />
            </Col>
          </Row>
          <h5>Company Details</h5>
          <Row className="spacing-16">
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppTextInput
                label="Name"
                name="company_name"
                placeholderText=""
                value={visaRequest.company_name}
                onChange={(e) =>
                  handleUpdateState('company_name', e.target.value)
                }
              />
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppTextInput
                label="Address"
                name="company_address"
                placeholderText=""
                value={visaRequest.company_address}
                onChange={(e) =>
                  handleUpdateState('company_address', e.target.value)
                }
              />
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppTextInput
                label="Designation"
                name="designation"
                placeholderText=""
                value={visaRequest.designation}
                onChange={(e) =>
                  handleUpdateState('designation', e.target.value)
                }
              />
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppTextInput
                label="Tel No"
                name="company_number"
                placeholderText=""
                value={visaRequest.company_number}
                onChange={(e) =>
                  handleUpdateState('company_number', e.target.value)
                }
              />
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppTextInput
                label="Email Id"
                name="company_email_id"
                placeholderText=""
                value={visaRequest.company_email_id}
                onChange={(e) =>
                  handleUpdateState('company_email_id', e.target.value)
                }
              />
            </Col>
          </Row>
        </div>
        <div className="visa-page_container_form my-2">
          <h5>Invitee Company</h5>
          <Row className="spacing-16">
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppTextInput
                label="Company Name"
                name="invitee_company_name"
                placeholderText=""
                value={visaRequest.invitee_company_name}
                onChange={(e) =>
                  handleUpdateState('invitee_company_name', e.target.value)
                }
              />
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppTextInput
                label="Address"
                name="invitee_company_address"
                placeholderText=""
                value={visaRequest.invitee_company_address}
                onChange={(e) =>
                  handleUpdateState('invitee_company_address', e.target.value)
                }
              />
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppNumberInput
                label="Tel No"
                name="invitee_company_number"
                placeholderText=""
                value={visaRequest.invitee_company_number}
                onChange={(e) => handleUpdateState('invitee_company_number', e)}
              />
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppTextInput
                label="Email Id"
                name="invitee_company_mail"
                placeholderText=""
                value={visaRequest.invitee_company_mail}
                onChange={(e) =>
                  handleUpdateState('invitee_company_mail', e.target.value)
                }
              />
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppTextInput
                label="contact Person Name"
                name="contact_name"
                placeholderText=""
                value={visaRequest.contact_name}
                onChange={(e) =>
                  handleUpdateState('contact_name', e.target.value)
                }
              />
            </Col>
          </Row>
        </div>
        <div className="visa-page_container_form my-2">
          <h5>Invitee Person</h5>
          <Row className="spacing-16">
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppTextInput
                label="Name"
                name="invitee_name"
                placeholderText=""
                value={visaRequest.invitee_name}
                onChange={(e) =>
                  handleUpdateState('invitee_name', e.target.value)
                }
              />
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppTextInput
                label="Address"
                name="invitee_address"
                placeholderText=""
                value={visaRequest.invitee_address}
                onChange={(e) =>
                  handleUpdateState('invitee_address', e.target.value)
                }
              />
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppNumberInput
                label="Tel No"
                name="invitee_mobile"
                placeholderText=""
                value={visaRequest.invitee_mobile}
                onChange={(e) => handleUpdateState('invitee_mobile', e)}
              />
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppTextInput
                label="Email Id"
                name="invitee_email"
                placeholderText=""
                value={visaRequest.invitee_email}
                onChange={(e) =>
                  handleUpdateState('invitee_email', e.target.value)
                }
              />
            </Col>
          </Row>
        </div>
        <div className="visa-page_container_form d-flex justify-content-center">
          <AppButton btnText="Submit" onClick={handleSubmit} />
        </div>
      </div>
    </div>
  );
}

export default VisaPage;
